import PropTypes from 'prop-types';
import React from 'react';
import FormInput from '../FormInput';
import inputTypes from '../FormInput/inputTypes';
import './style.scss';

export default function FormRadioGroup({
  label = '',
  radioOptions = [],
  checkedItem = '',
  wrapClass = '',
  radioWrapClass = '',
  radioLabelClass = '',
  onChange = () => {},
  radioClass = ''
}) {
  return (
    <fieldset className={`radio-group__wrap ${wrapClass}`}>
      {label&& <legend className={`radio-group__label ${radioLabelClass}`}>{label}</legend> }
      {radioOptions.map((option, index) => {
        return <FormInput
            id={ option.id?.toString()}
            inputClass={`radio-item ${radioClass}`}
            key={`id-${index}`}
            wrapClass={radioWrapClass}
            label={option.name}
            labelClass={`radio__label ${radioLabelClass}`}
            type={inputTypes.radio}
            value={option.id}
            checked={checkedItem === option.id?.toString()}
            onChange={(e) => {
              onChange(e);
            }}
        />
      })}
    </fieldset>
  );
}

FormRadioGroup.propTypes = {
  label: PropTypes.string,
  radioOptions: PropTypes.array.isRequired,
  checkedItem: PropTypes.string,
  wrapClass: PropTypes.string,
  radioWrapClass: PropTypes.string,
  radioLabelClass: PropTypes.string,
  onChange: PropTypes.func,
  radioClass: PropTypes.string
};
